import {
  Box,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';

import Modal from '../../../../components/Modal';

function DeleteConfirmationDialog({
  open,
  handleClose,
  selectedColours,
  colourGroupName,
  handleDeleteColours,
}) {
  const totalSelected = (selectedColours.length > 0) ? selectedColours.length : 0;
  return (
    <Modal
      open={open}
      onClose={handleClose}
      title="Delete selected Swatch colours"
      containerWidth="sm"
      titleVariant="h4"
      desktopModalWidth="35%"
      desktopModalHeight="45vh"
      buttonLabel="DELETE"
      buttonOnClick={handleDeleteColours}
      buttonColour="primary"
      roundedButton
    >
      <Typography className="text-lg font-bold text-center text-red-700 -mt-9">
        {totalSelected}
        {' '}
        selected
      </Typography>
      <Box display="flex" gap={1}>
        <Stack className="w-1/2">
          <Box
            sx={{
              borderRadius: '4px',
              padding: '16px 16px 16px 16px',
              overflow: 'auto',
            }}
          >
            <span className="text-lg font-bold text-red-700">FROM</span>
            {' '}
            <span className="text-3xl font-bold">{colourGroupName}</span>
          </Box>
        </Stack>
        <Divider orientation="vertical" variant="middle" flexItem />
        <Stack className="w-1/2 mt-2">
          <div className="mt-3 ml-3 overflow-y-auto custom-scrollbar max-h-52">
            {selectedColours.map((colour) => (
              <Typography variant="h6">
                {colour}
              </Typography>
            ))}
          </div>
        </Stack>
      </Box>
    </Modal>
  );
}

export default DeleteConfirmationDialog;
